module.exports = __webpack_public_path__ + "static/media/grayLogo.38c5fed8.svg";